<template>
  <div>
    <header class="login-header">

    </header>
    <div class="login page">
      <form @submit.prevent="login">
        <input v-model="password" type="password" placeholder="Lösenord" />
        <button type="submit" class="login-btn">Logga in</button>
      </form>
    </div>
  </div>
</template>

<script>
  
  export default {
    data: function(){
      return {
        loading: false, 
        loginRequired: false,
        password: ''
      }
    }, 
    mounted: function () {

    },
    methods: {
      login: async function(){
        this.$store.dispatch('login', this.password).then(() => {
          if(this.$store.state.authenticated){
            this.$router.push('/list')
          }else{
            alert("Invalid password");
          }
        })
      }
    }
  }
</script>